module.exports = __webpack_public_path__ + "static/img/cont52 (3).82ee14a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont52 (3).jpg
// module id = AZXS
// module chunks = 0